<template>
  <v-container class="text-xs-left">
    <span class="headline">Vorteile von Premium auf einem Blick</span>
    <span class="prominent">- Weitere Dokument Status konfigurierbar z.b. (bezahl, noch zu zahlen, usw.)</span>
    <span class="prominent">- OCR Erkennung für PDF Bild Dateien</span>
    <span class="prominent">- Frei definierbare Kategorie Felder (netto, brutto, usw.)</span>
  </v-container>
</template>

<script>
export default {
  name: 'Vorteilepremium',
  data () {
    return {
    }
  },
  methods: {
    myMethod: function () {
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
.prominent {
  display: block;
  font-weight: bold;
  color: #0c425a;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/Vorteilepremium.vue